<template>
  <Modal title="更多筛选" width="620px" :visible="visible" @confirm="confirm" @cancel="cancel">
    <ElForm ref="formRef" class="compare-form" :model="compareForm" :rules="rules" label-width="120px">
      <ElFormItem label="实际消耗" prop="amountValue">
        <div class="compare-form-item">
          <ElSelect v-model="compareForm.amountOperatorType" class="operator-select">
            <ElOption v-for="item in COMPARE_OPERATOR_OPTIONS" :key="item.value" :label="item.label" :value="item.value" />
          </ElSelect>
          <ElInput v-model="compareForm.amountValue" clearable placeholder="请输入">
            <span slot="append">元</span>
          </ElInput>
        </div>
      </ElFormItem>

      <ElFormItem label="新创角回款率" prop="newRoleRateValue">
        <div class="compare-form-item">
          <ElSelect v-model="compareForm.newRoleRateOperatorType" class="operator-select">
            <ElOption v-for="item in COMPARE_OPERATOR_OPTIONS" :key="item.value" :label="item.label" :value="item.value" />
          </ElSelect>
          <ElInput v-model="compareForm.newRoleRateValue" clearable placeholder="请输入">
            <span slot="append">%</span>
          </ElInput>
        </div>
      </ElFormItem>
    </ElForm>

    <div class="clear-row">
      <ElButton type="text" @click="clearForm">清空筛选项</ElButton>
    </div>
  </Modal>
</template>

<script setup>
import { nextTick, reactive, ref, watch } from 'vue'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import { COMPARE_OPERATOR_OPTIONS } from '../hooks/useFilter'

// eslint-disable-next-line
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  value: {
    type: Object,
    required: true
  }
})
// eslint-disable-next-line
const emit = defineEmits(['update:visible', 'input', 'confirm'])

const getDefaultForm = () => ({
  amountOperatorType: 5,
  amountValue: '',
  newRoleRateOperatorType: 5,
  newRoleRateValue: ''
})

const formRef = ref(null)
const compareForm = reactive(getDefaultForm())
const isEmpty = (value) => value === undefined || value === null || value === ''

const validateAmount = (rule, value, callback) => {
  const amount = String(value).trim()
  if (!amount || /^\d+$/.test(amount)) return callback()
  callback(new Error('请输入合法金额'))
}

const validateRate = (rule, value, callback) => {
  const rate = String(value).trim()
  if (!rate) return callback()
  if (/^\d+(\.\d+)?$/.test(rate) && Number(rate) >= 0 && Number(rate) <= 100) return callback()
  callback(new Error('取值范围 0~100'))
}

const rules = {
  amountValue: [{ validator: validateAmount, trigger: ['blur', 'change'] }],
  newRoleRateValue: [{ validator: validateRate, trigger: ['blur', 'change'] }]
}

const refillForm = () => {
  Object.assign(compareForm, getDefaultForm(), {
    ...props.value,
    amountValue: isEmpty(props.value.amountValue) ? '' : String(props.value.amountValue),
    newRoleRateValue: isEmpty(props.value.newRoleRateValue) ? '' : String(props.value.newRoleRateValue)
  })
  nextTick(() => formRef.value?.clearValidate())
}

watch(
  () => props.visible,
  (visible) => {
    if (visible) refillForm()
  }
)

const cancel = () => {
  emit('update:visible', false)
}

const clearForm = () => {
  Object.assign(compareForm, getDefaultForm())
  nextTick(() => formRef.value?.clearValidate())
}

const normalizeValue = (value) => {
  const normalized = String(value).trim()
  return normalized === '' ? undefined : Number(normalized)
}

const confirm = () => {
  formRef.value.validate((valid) => {
    if (!valid) return
    emit('input', {
      amountOperatorType: compareForm.amountOperatorType,
      amountValue: normalizeValue(compareForm.amountValue),
      newRoleRateOperatorType: compareForm.newRoleRateOperatorType,
      newRoleRateValue: normalizeValue(compareForm.newRoleRateValue)
    })
    emit('update:visible', false)
    nextTick(() => emit('confirm'))
  })
}
</script>

<style lang="scss" scoped>
.compare-form-item {
  display: grid;
  grid-template-columns: 110px 1fr;
  align-items: center;
  gap: 14px;
  width: 430px;
}

.compare-form {
  ::v-deep .el-form-item + .el-form-item {
    margin-top: 18px;
  }
}

.clear-row {
  text-align: right;
}
</style>
